import { getPhoneMask } from "@/utils/string/get-phone-mask";

export const usePhoneMask = (phone: Ref<string | null | undefined>) => {
  const mask = computed(() => getPhoneMask(phone.value ?? ""));

  return mask;
};
